import React, { useEffect, useState } from "react";
import ReusableTable from "../../../../components/Table";
import { FileUploader } from "../../../../components/ImageUploader";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import Select from "react-select";
import { API_URL } from "../../../../constants";
import { ToastContainer, toast } from "react-toastify";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import checkPermission from "../../../../components/checkPermission";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import No_Image_Available from '../../../../assets/No_Image_Available.jpg'
const BirthdayCard = () => {
  const navigate = useNavigate();
  const [birthDayDetails, setBirthDayDetails] = useState([]);
  const [EmployeeListdata, setEmployeeListdata] = useState([]);
  const [profilePic, setProfilePic] = useState('');
  const [searchTerm, setSearchTerm] = useState("");
  const [isAdding, setIsAdding] = useState(false);
  const [value, setValue] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [fileName, setFileName] = useState(null);
  const [formData, setFormData] = useState({
    employee_id: "",
    fileName: "",
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [editId, setEditId] = useState(null);
  const [apiStatus, SetApiStatus] = useState(undefined);


  const userImage = JSON.parse(localStorage.getItem('user'))
//   useEffect(()=>{
// setProfilePic(userImage?.ProfileImagePath)
//   },[userImage])
  const hanldeChange = (selected, name) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: selected.value,
    }));
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const columns = {
    EmpCode: { text: "EMP ID", width: "10%", align: "start", visible: true },
    EmployeeName: {
      text: "Employee Name",
      width: "40%",
      align: "start",
      visible: true,
    },
    DateOfBirth: {
      text: "Date Of Birth",
      width: "20%",
      align: "center",
      visible: true,
    },
    FileName: {
      text: "Birthday Image",
      width: "20%",
      align: "center",
      type: "Image",
      visible: true,
    },
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Birthday Details"));
  }, []);

  const resetFormState = () => {
    setValue(null);
    setFileName("");
    setProfilePic("");
    setFormData({
      selectedOption: null,
      checkedItems: [],
    });
    setErrorMessage("");
  };

  const [employeeOptions, setEmployeeOptions] = useState([]);

  const fetchData = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}birthday-card`);

      if (response?.status === 200) {
        const data = response?.data?.data;
        setBirthDayDetails(data);

        const empOtp = response?.data?.employee_list?.map((o) => ({
          value: o.value,
          label: o.text,
        }));
        setEmployeeOptions(empOtp);
        SetApiStatus(response?.status);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    let permission = checkPermission("Birthday", "view");
 
    if (!permission.status) {
      window.location = permission.redirect_url;
    }
    fetchData();
  }, []);

  const handleEditModalClose = () => {
    setShowEditModal(false);
  };

  const handleFile = (file) => {
    const fileType = file.type;
    const fileSize = file.size;
    if (fileType !== "image/png" && fileType !== "image/jpeg") {
      setErrorMessage("Only PNG and JPEG formats are allowed.");
      return;
    }
    if (fileSize > 300 * 1024) {
      // 300 KB
      setErrorMessage("File size should be less than 300 KB.");
      return;
    }
    setErrorMessage("");
    // setFileName(file);
    const previewUrl = URL.createObjectURL(file);
    setProfilePic(previewUrl);
    setFormData((prevState) => ({
      ...prevState,
      fileName: file,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData?.employee_id || !formData?.fileName) {
      setErrorMessage("Please select a image.");
      return;
    }
    const data = new FormData();
    data.append("EmployeeID", formData?.employee_id);
    data.append("BirthdayImage", formData?.fileName);

    try {
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      await PostFormServiceCaller(
        `${API_URL}birthday-card-store`,
        data,
        "post"
      );
      toast.success("Data submitted successfully!");
      setErrorMessage("");
      setShowEditModal(false);
      fetchData(); // Refresh the table data
    } catch (error) {
      toast.error("Error submitting data.");
      setErrorMessage("Error submitting data.");
      console.error("Error submitting data:", error);
    }
  };
  const handleEdit = async (id) => {
    let selected_emp = { label: id.EmployeeName, value: id.emp_id.ID };

  
    setFormData((prevState) => ({
      ...prevState,
      employee_id: selected_emp.value,
      fileName:id.FileName
    }));
    setIsAdding(false);
    setEditId(id);
    setShowEditModal(true);
    setIsEditMode(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}birthday-card/${id.emp_id.ID}`
      );
      const data = response?.data?.birthdaydetails;

      setValue({ value: data.EmployeeID, label: data.EmployeeName });
      setFileName(data.FileName);
      setProfilePic(data.file); // Adjust according to your image path
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleAddBirthday = () => {
    setShowEditModal(true);
    resetFormState();
    setIsEditMode(false);
    // navigate("/birthday-card/add");
  };

  const handleCancel = () => {
    setShowEditModal(false);
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
        <div className="row mt-2">
          <Dynamic_PR_table
            data={birthDayDetails}
            columns={columns}
            itemsPerPage={10}
            searchTerm={searchTerm}
            isActionRequired={true}
            setSearchTerm={setSearchTerm}
            showIcon1={true}
            showIcon2={false}
            showIcon3={false}
            showIcon4={false}
            showIcon5={false}
            isFilterRequired={false}
            isSorting={false}
            isApiStatus={apiStatus}
            isRequiredStatus={true}
            isAddNewBtnRequired={true}
            hanldeImageClick={handleImageClick}
            handleAddNew={handleAddBirthday}
            handleIcon1={handleEdit}
            add
            more
            function
            icons={{
              Icon1: <i class="bi bi-pencil-square icons"></i>,
              Icon2: <i class="bi bi-people-fill icons"></i>,
              Icon2Text: " Employee Selection",
              Icon3Text: "Interview Status",
              Icon3: <i class="bi bi-box-arrow-up-right icons"></i>,
              Icon4: <i class="bi bi-envelope icons"></i>,
              Icon4Text: "Send JD",
              Icon5Text: "JD",
              Icon5: <i class="bi bi-eye-fill icons"></i>,
            }}
          />
        </div>
      </div>
      </div>

      <Modal show={isModalOpen} onHide={closeModal} centered size="md">
        <img
          src={selectedImage}
          alt="Enlarged Profile"
          style={{ maxWidth: "100%", maxHeight: "70vh" }}
        />
      </Modal>

   <Modal
  show={showEditModal}
  onHide={handleEditModalClose}
  centered
  dialogClassName="custom-modal"
>
  <div style={{ width: "400px", margin: "0 auto" }}>
    <Modal.Header >
      <Modal.Title>
        <h4 style={{ marginBottom: 0, fontWeight: "bold" }}>Birthday Details</h4>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body style={{ padding: "20px" }}>
      <Form onSubmit={handleSubmit}>
        <p style={{ fontSize: "14px", color: "#6c757d", marginBottom: "10px" }}>
          *Upload photo size should be less than 300KB
        </p>

        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <img
            id="profilePic"
            style={{
              width: "160px",
              height: "160px",
              objectFit: "cover",
              backgroundColor: profilePic ? "transparent" : "#ddd",
              border: profilePic ? "none" : "1px solid #ccc",
              borderRadius: "8px",
            }}
            src={profilePic || No_Image_Available}
            onError={(e) => {
              e.target.src = No_Image_Available;
              e.target.style.backgroundColor = "#ddd";
              e.target.style.border = "1px solid #ccc";
            }}
            alt="Birthday Pic"
          />

          <div style={{ marginTop: "10px" }}>
            <FileUploader handleFile={handleFile} />
            {fileName && (
              <p style={{ margin: "5px 0" }}>Upload: {fileName}</p>
            )}
            <span style={{ color: "red" }}>*</span>
          </div>

          {errorMessage && (
            <span style={{ color: "red", fontSize: "13px" }}>
              {errorMessage}
            </span>
          )}
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label style={{ fontWeight: "600", display: "block", marginBottom: "5px" }}>
            Employee Name <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            value={employeeOptions?.find(
              (o) => o.value === formData.employee_id
            )}
            name="employee_id"
            classNamePrefix="select"
            onChange={(selected) => hanldeChange(selected, "employee_id")}
            options={employeeOptions}
            placeholder="Select Employee"
            isDisabled={isEditMode}
          />
          {!formData.employee_id && errorMessage && (
            <span style={{ color: "red", fontSize: "13px" }}>
              Employee Name is required
            </span>
          )}
        </div>

        

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
           className="cancel-btn me-2"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <button
             className="custom-btn"
             type="submit"
          >
            Submit
          </button>
        </div>
      </Form>
    </Modal.Body>
  </div>
</Modal>


    </>
  );
};

export default BirthdayCard;
